import React, { useState, useContext, useCallback } from "react";
import contactCardStyle from "./ContactCard.module.scss";
import classnames from "classnames";
import { AppContext } from "@vahak/core/dist/app-context";
import A from "@vahak/core/dist/components/app-anchor/A";

export interface ContactUsCardProps {
    icon?: JSX.Element | undefined;
    className?: string;
    heading: string;
    contentText: string;
    specialText?: string;
    footerText: string;
    aHref?: string;
    onClickCard?: () => void;
}

const ContactUsCard = ({
    icon,
    className,
    heading,
    contentText,
    specialText,
    footerText,
    onClickCard
}: ContactUsCardProps) => {
    const { isMobile } = useContext(AppContext);
    const [isCardHovered, setIsCardHovered] = useState(false);

    const onHover = useCallback(() => {
        setIsCardHovered(true);
    }, []);

    const onMouseOut = useCallback(() => {
        setIsCardHovered(false);
    }, []);
    return (
        <>
            <A onClick={onClickCard}>
                <div
                    className={classnames(
                        contactCardStyle.contactcard,
                        isMobile
                            ? contactCardStyle.contactcard__mobile__container
                            : contactCardStyle.contactcard__desktop__container,
                        isCardHovered && contactCardStyle.hover,
                        className
                    )}
                    onMouseEnter={onHover}
                    onMouseLeave={onMouseOut}
                >
                    <div
                        className={classnames(
                            contactCardStyle.contactCardHeader,
                            isMobile ? contactCardStyle.contactCardHeader__mob : contactCardStyle.contactCardHeader__web
                        )}
                    >
                        {icon}
                    </div>
                    <div
                        className={classnames(
                            contactCardStyle.headingTextCommon,
                            isMobile ? contactCardStyle.headingText__mob : contactCardStyle.headingText__web
                        )}
                    >
                        {isMobile ? heading : <h3>{heading}</h3>}
                    </div>
                    <p
                        className={classnames(
                            contactCardStyle.contentTextCommon,
                            isMobile ? contactCardStyle.contentText__mob : contactCardStyle.contentText__web
                        )}
                    >
                        {contentText}
                        <span
                            className={classnames(
                                contactCardStyle.headingTextCommon,
                                isMobile ? contactCardStyle.specialText__mob : contactCardStyle.specialText__web
                            )}
                        >
                            {specialText}
                        </span>
                    </p>
                    <A
                        className={classnames(
                            contactCardStyle.footerCommon,
                            isMobile ? contactCardStyle.footerText__mob : contactCardStyle.footerText__web
                        )}
                    >
                        {footerText}
                    </A>
                </div>
            </A>
        </>
    );
};

export default ContactUsCard;
